import React from 'react'
import UploadFileComponent from '../../common/UploadFileComponent'

export default () => (<UploadFileComponent
  dataUploadUrl={'/api/spreadsheet/carriers/replace'}
  description='Upload a csv file that contains material information (for Product Concept Analysis)'
  supportedFileFormats={['.xlsx', '.xlsm']}
/>)
